import { store } from './store.js';
// 1. Initial Imports
import { safeSetHTML } from './security.js';

/**
 * UI MANAGER - Detectimáticas de 1º
 * Gestión de la interfaz, idiomas (i18n) y elementos visuales.
 */

const UIManager = {
    init() {
        Logger.info('🖥️ Inicializando window.UIManager...');
        this.renderWelcomeScreen(true); // Play audio on initial load
        this.updateUILanguage();
        this.populateLanguageMenu();
        this.populateContextsPreview();
    },

    renderWelcomeScreen(playAudio = false) {
        const nav = document.querySelector('#welcomeScreen .main-nav');
        if (!nav) return;
        safeSetHTML(nav, '');

        // --- ADD ADULT ACCESS BUTTON (PARENTAL GATE) ---
        let adultBtn = document.getElementById('adultAccessBtn');
        if (!adultBtn) {
            adultBtn = document.createElement('button');
            adultBtn.id = 'adultAccessBtn';
            adultBtn.innerHTML = '⚙️ Área de Gestión';
            adultBtn.style.cssText = 'position: absolute; top: 20px; right: 20px; background: rgba(255,255,255,0.6); border: 2px solid #cbd5e1; color: #475569; font-size: 0.9rem; font-weight: bold; padding: 8px 16px; border-radius: 20px; cursor: pointer; box-shadow: 0 2px 5px rgba(0,0,0,0.1); z-index: 100; transition: all 0.2s ease; backdrop-filter: blur(5px);';
            
            adultBtn.onmouseover = () => adultBtn.style.background = 'rgba(255,255,255,0.95)';
            adultBtn.onmouseout = () => adultBtn.style.background = 'rgba(255,255,255,0.6)';
            
            adultBtn.onclick = () => {
                if (window.stopAudio) window.stopAudio();
                this.showTeacherPinModal();
            };
            
            const welcomeScreen = document.getElementById('welcomeScreen');
            if (welcomeScreen) {
                welcomeScreen.style.position = 'relative';
                welcomeScreen.appendChild(adultBtn);
            }
        }
        // -----------------------------------------------


        // 1. Start Buttons (Row 1) - Responsive Split Layout
        const startContainer = document.createElement('div');
        startContainer.style.cssText = 'display: flex; flex-direction: row; justify-content: center; align-items: stretch; gap: 15px; width: clamp(280px, 95%, 1000px); margin: 0 auto clamp(1.5rem, 4vh, 3rem); flex-wrap: wrap;';

                const identifyBtn = this.createButton({
            id: 'identifyBtn',
            class: 'btn btn-secondary',
            text: '🕵️‍♂️ Soy un Detective',
            icon: '',
            style: 'flex: 1; min-width: 200px; margin: 0; padding: clamp(1.5rem, 3vh, 2rem) 1rem; font-size: clamp(1.3rem, 3vw, 1.8rem); min-height: clamp(100px, 15vh, 140px); border-radius: 20px; background: linear-gradient(135deg, #0ea5e9, #0284c7); color: white; display: flex; align-items: center; justify-content: center; box-shadow: 0 8px 20px rgba(14, 165, 233, 0.3); text-shadow: 0 1px 2px rgba(0,0,0,0.3);',
            ariaLabel: 'Identificarse o entrar con perfil de colegio'
        });
        identifyBtn.onclick = () => {
            if (window.stopAudio) window.stopAudio();
            if (window.SessionManager) window.SessionManager.hideAllScreens();
            
            // Critical fix: Always use the global function to initialize logic
            if (typeof window.showLoginScreen === 'function') {
                window.showLoginScreen(true);
            } else {
                const loginScreen = document.getElementById('loginScreen');
                if (loginScreen) {
                    loginScreen.classList.remove('hidden');
                    loginScreen.classList.add('active');
                }
            }
        };

        const startAdventureBtn = this.createButton({
            id: 'welcomeStartAdventureBtn',
            class: 'btn btn-primary',
            text: '🤫 MISIÓN SECRETA',
            icon: '',
            style: 'flex: 1; min-width: 200px; margin: 0; padding: clamp(1.5rem, 3vh, 2rem) 1rem; font-size: clamp(1.3rem, 3vw, 1.8rem); min-height: clamp(100px, 15vh, 140px); border-radius: 20px; box-shadow: 0 10px 25px rgba(250, 204, 21, 0.4); display: flex; align-items: center; justify-content: center;',
            ariaLabel: 'Misión secreta rápida'
        });
        startAdventureBtn.onclick = () => {
            if (window.stopAudio) window.stopAudio();
            if (window.UserManager) window.UserManager.loginGuest();
            if (window.LoginScreen && window.LoginScreen.initGlobalServices) {
                window.LoginScreen.initGlobalServices();
            }
            if (window.SessionManager) {
                window.SessionManager.showConfigScreen();
            }
            if (window.ConfigManager) {
                window.ConfigManager.isSecretMission = true;
                setTimeout(() => window.ConfigManager.openSelection('levelSection'), 100);
            }
        };

        const detectiveZoneBtn = this.createButton({
            id: 'detectiveZoneBtn',
            class: 'btn btn-secondary',
            text: '⭐ Zona Secreta',
            icon: '',
            style: 'flex: 1; min-width: 200px; margin: 0; padding: clamp(1.5rem, 3vh, 2rem) 1rem; font-size: clamp(1.3rem, 3vw, 1.8rem); min-height: clamp(100px, 15vh, 140px); border-radius: 20px; background: linear-gradient(135deg, #d946ef, #9333ea); color: white; display: flex; align-items: center; justify-content: center; box-shadow: 0 8px 20px rgba(147, 51, 234, 0.4); text-shadow: 0 1px 2px rgba(0,0,0,0.3); border: 2px solid #fdf4ff;',
            ariaLabel: 'Abrir opciones de la Zona Detective'
        });
        detectiveZoneBtn.onclick = () => {
            if (window.stopAudio) window.stopAudio();
            if (window.DetectiveZoneModal) {
                window.DetectiveZoneModal.open();
            }
        };

        // Cambiar el orden: COMENZAR a la izquierda, IDENTIFICARSE en el centro
        startContainer.appendChild(startAdventureBtn);
        startContainer.appendChild(identifyBtn);
        startContainer.appendChild(detectiveZoneBtn);
        nav.appendChild(startContainer);

        // 2. Exit Button (Responsively centered below)
        const exitContainer = this.createButtonContainer('100%', '0 auto 2rem', true);
        const exitBtn = this.createButton({
            id: 'exitBtn',
            class: 'btn',
            text: 'SALIR',
            icon: '✕',
            style: 'width: clamp(150px, 30%, 250px); padding: 0.8rem 1.5rem; font-size: clamp(1rem, 2vw, 1.2rem); background-color: #ef4444; color: #FFFFFF; border: 3px solid #b91c1c; border-radius: 20px; font-weight: 900; box-shadow: 0 4px 10px rgba(239, 68, 68, 0.3); display: flex; align-items: center; justify-content: center; gap: 8px; transition: transform 0.2s;'
        });
        exitBtn.onclick = () => {
            if (window.UserManager && window.UserManager.logout) {
                window.UserManager.logout();
                window.location.reload();
            } else {
                window.close();
            }
        };
        const exitIcon = exitBtn.querySelector('.btn-icon');
        if (exitIcon) {
            exitIcon.style.color = '#FFFFFF';
            exitIcon.style.fontSize = '1.4rem';
        }

        exitContainer.appendChild(exitBtn);
        nav.appendChild(exitContainer);

        // Play welcome audio if requested
        if (playAudio && window.playWelcomeMessage) {
            window.playWelcomeMessage(true);
        }
    },

    createButtonContainer(width, margin = '0', flexCenter = true, isMini = false) {
        const div = document.createElement('div');
        div.className = isMini ? 'home-action-item mini' : 'home-action-item';
        div.style.width = width;
        if (margin) div.style.margin = margin;
        // Basic flex styles if requested, though some callers override
        if (flexCenter) {
            div.style.display = 'flex';
            div.style.alignItems = 'center';
            div.style.justifyContent = 'center';
            if (!isMini) div.style.gap = '10px';
        }
        return div;
    },

    createButton({ id, class: className, text, icon, style, ariaLabel }) {
        const btn = document.createElement('button');
        btn.id = id;
        btn.className = className;
        if (style) btn.style.cssText = style;
        if (ariaLabel) btn.setAttribute('aria-label', ariaLabel);

        const iconSpan = document.createElement('span');
        iconSpan.className = 'btn-icon';
        iconSpan.textContent = icon;
        if (style && style.includes('font-size')) {
            iconSpan.style.fontSize = '1rem';
            iconSpan.style.margin = '0';
        }

        const textSpan = document.createElement('span');
        textSpan.id = `${id}Text`; // Convention for text updaters
        textSpan.textContent = text;
        textSpan.style.display = 'block';

        btn.appendChild(iconSpan);
        btn.appendChild(textSpan);

        return btn;
    },

    updateUILanguage() {
        const lang = window.currentLanguage || 'es-ES';
        if (!window.LANGUAGES || !window.LANGUAGES[lang]) return;

        const strings = window.LANGUAGES[lang].strings;

        // Actualizar textos de la UI principal
        const setTxt = (id, txt) => {
            const el = document.getElementById(id);
            if (el && txt) el.innerHTML = txt;
        };

        setTxt('mainTitle', strings.title);
        setTxt('startBtnText', '▶️ JUGAR AHORA');
        setTxt('languageBtnText', strings.selectLanguage);
        setTxt('exitBtnText', strings.exit);

        // Global navigation buttons
        setTxt('homeText', strings.home);
        setTxt('exitAppText', strings.exit);

        // Actualizar título del menú de idiomas
        const selectLanguageTitle = document.getElementById('selectLanguageTitle');
        if (selectLanguageTitle) {
            selectLanguageTitle.textContent = `${strings.selectLanguage} / ${window.LANGUAGES[lang].nativeName}`;
        }

        // Actualizar título de contextos
        setTxt('contextsTitle', strings.contexts);

        setTxt('tableSelectTitle', strings.tableSelectTitle);
        setTxt('tableCloseBtn', strings.close);

        // Para abnTitle mantenemos el icono
        const abnTitle = document.getElementById('abnTitle');
        if (abnTitle && strings.abnTitle) abnTitle.textContent = `📊 ${strings.abnTitle}`;

        setTxt('abnCalculatingLabel', strings.abnCalculating);
        setTxt('abnStepsTitle', strings.abnSteps);
        setTxt('abnPrevText', strings.abnPrev);
        setTxt('abnNextText', strings.abnNext);
        setTxt('abnUseText', strings.abnUse);

        // Wizard Step Labels
        const stepLabels = ['wizardStep1Label', 'wizardStep2Label', 'wizardStep3Label',
            'wizardStep4Label', 'wizardStep5Label', 'wizardStep6Label'];
        stepLabels.forEach((id) => {
            const stepLabel = document.getElementById(id);
            if (stepLabel && strings[id]) stepLabel.textContent = strings[id];
        });

        // Wizard Step Titles and Instructions
        setTxt('step1Title', strings.wizardStep1Title);

        setTxt('step1Question', strings.wizardStep1Question);
        setTxt('step2Title', strings.wizardStep2Title);
        setTxt('step2Instruction', strings.wizardStep2Instruction);
        setTxt('step3Title', strings.wizardStep3Title);
        setTxt('step3Instruction', strings.wizardStep3Instruction);
        setTxt('step4Title', strings.wizardStep4Title);
        setTxt('step5Title', strings.wizardStep5Title);
        setTxt('step5Instruction', strings.wizardStep5Instruction);
        setTxt('step6Title', strings.wizardStep6Title);
        setTxt('step6Instruction', strings.wizardStep6Instruction);

        setTxt('comprehendedBtn', strings.wizardStep1Yes);
        if (strings.wizardStep1HelpHeader) setTxt('step1HelpHeader', strings.wizardStep1HelpHeader);
        if (strings.wizardStep1HelpQuestions) setTxt('helpQuestionsBtn', strings.wizardStep1HelpQuestions);
        setTxt('helpBtn', strings.wizardStep1HelpSchema || strings.wizardStep1Help);
        setTxt('validateHighlightBtn', strings.validateHighlight);
        setTxt('validateRepresentationBtn', strings.validateRepresentation);
        setTxt('submitAnswerBtn', strings.submitAnswer);

        setTxt('questionModeBtn', strings.highlightQuestion);
        setTxt('usefulModeBtn', strings.highlightUseful);
        setTxt('clearHighlightsBtn', strings.highlightClear);

        setTxt('largestDataLabel', strings.largestDataLabel);
        setTxt('rememberQuestionLabel', strings.rememberQuestion);

        setTxt('method1Title', strings.method1Title);
        setTxt('method2Title', strings.method2Title);
        setTxt('method3Title', strings.method3Title);
        setTxt('checkCalcTableBtn', strings.checkButton);
        setTxt('selectNumberBtn', strings.selectNumberBtn);

        setTxt('summaryLabel', strings.summaryLabel);
        setTxt('summaryOperationLabel', strings.summaryOperation);
        setTxt('summaryResultLabel', strings.summaryResult);

        setTxt('prevStepBtn', strings.previousStep || strings.previous);
        setTxt('nextStepBtn', strings.nextStep || strings.continue);
        setTxt('finishSessionBtn', strings.finishSession);
        setTxt('startAdventureBtn', strings.startAdventure);

        setTxt('problemTypeTitleText', strings.problemTypeTitle ? `1. ${strings.problemTypeTitle}` : null);
        setTxt('levelTitleText', strings.levelTitle ? `2. ${strings.levelTitle}` : null);
        setTxt('contextTitleText', strings.contextTitle ? `3. ${strings.contextTitle}` : null);

        setTxt('sessionCompleteTitle', strings.sessionComplete);
        setTxt('yourScoreLabel', strings.yourScore);
        setTxt('excellentWorkMsg', strings.excellentWork);
        setTxt('newSessionBtn', strings.newSession);
        setTxt('backToHomeBtn', strings.backToHome);

        setTxt('loadingText', strings.loading);
        setTxt('lastSelectedLabel', strings.lastSelected);
        setTxt('sendAnswerBtn', strings.sendAnswer);
        setTxt('resetTableBtn', strings.resetTable);
        setTxt('showHelpBtn', strings.showHelp);
        setTxt('hideHelpBtn', strings.hideHelp);
        setTxt('tableBackBtn', strings.tableScreenBack);

        // Re-render grids if necessary
        if (store.config) {
            if (store.config.currentStep === 1 && window.renderProblemTypes) window.renderProblemTypes();
            if (store.config.currentStep === 2 && window.renderLevels) window.renderLevels();
            if (store.config.currentStep === 3 && window.renderContextSelection) window.renderContextSelection();
        }

        // Restaurar botones de audio
        setTimeout(() => {
            if (window.addSafeAudioButtons) window.addSafeAudioButtons();
        }, 100);

        Logger.log(`🌐 Idioma actualizado a: ${window.LANGUAGES[lang].nativeName}`);
    },


    populateContextsPreview() {
        const contextGrid = document.getElementById('contextGrid');
        if (!contextGrid || !window.CONTEXTS) return;

        contextGrid.innerHTML = '';
        const previewContexts = window.CONTEXTS.slice(0, 8);
        const lang = window.currentLanguage || 'es-ES';

        previewContexts.forEach(context => {
            const card = document.createElement('div');
            card.className = 'context-card';
            card.style.setProperty('--context-color', context.color);
            card.setAttribute('data-context-id', context.id);

            const title = document.createElement('h3');
            title.className = 'context-title';
            title.textContent = context?.name?.[lang] || context?.name?.['es-ES'];

            const description = document.createElement('p');
            description.className = 'context-description';
            description.textContent = context?.description?.[lang] || context?.description?.['es-ES'];

            const content = document.createElement('div');
            content.className = 'context-card-content';
            content.appendChild(title);
            content.appendChild(description);
            card.appendChild(content);

            contextGrid.appendChild(card);
        });
    },

    renderContextSelection() {
        const contextGrid = document.getElementById('contextGrid');
        if (!contextGrid || !window.CONTEXTS) return;

        contextGrid.innerHTML = ''; // Clear previous content
        const lang = window.currentLanguage || 'es-ES';

        // DEMO MODE: Allowed contexts
        const ALLOWED_CONTEXTS = ['cumpleanos', 'cumpleaños', 'fruteria', 'frutería'];

        window.CONTEXTS.forEach(context => {
            const card = document.createElement('div');
            const isAllowed = ALLOWED_CONTEXTS.includes(context.id);

            card.className = `context-card ${isAllowed ? 'selectable-card' : 'locked-card'}`;
            if (!isAllowed) card.style.opacity = '0.6';

            card.style.setProperty('--context-color', context.color);
            card.setAttribute('data-context-id', context.id);

            const title = document.createElement('h3');
            title.className = 'context-title';
            title.textContent = context?.name?.[lang] || context?.name?.['es-ES'];
            if (!isAllowed) title.textContent += ' 🔒';

            const description = document.createElement('p');
            description.className = 'context-description';
            description.textContent = context?.description?.[lang] || context?.description?.['es-ES'];

            const content = document.createElement('div');
            content.className = 'context-card-content';
            content.appendChild(title);
            content.appendChild(description);
            card.appendChild(content);

            card.addEventListener('click', () => {
                if (isAllowed) {
                    // Handle context selection logic
                    store.config.selectedContext = context.id;
                    Logger.log(`Context selected: ${context?.name?.[lang]}`);
                    // Proceed to next step or trigger an event
                    window.goToNextStep();
                } else {
                    // Show Demo Message
                    if (window.Swal) {
                        Swal.fire({
                            icon: 'info',
                            title: 'Modo Demo',
                            text: 'Estás utilizando una demo. Este contexto estará disponible en la versión completa.',
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#3085d6'
                        });
                    } else {
                        alert('Estás utilizando una demo. Estará disponible en la versión completa');
                    }
                    if (window.SoundService) window.SoundService.playError();
                }
            });

            contextGrid.appendChild(card);
        });
    },

    populateLanguageMenu() {
        const listContainer = document.getElementById('languageList');
        if (!listContainer) return;

        listContainer.innerHTML = ''; // Clear previous contents

        if (!window.LANGUAGES) return;

        Object.keys(window.LANGUAGES).forEach(langCode => {
            const lang = window.LANGUAGES[langCode];
            const btn = document.createElement('button');
            btn.className = 'language-option btn';

            // Minimal inline styles, classes will do the rest
            if (window.currentLanguage === langCode) {
                btn.classList.add('selected');
            }

            btn.innerHTML = `
                <span class="lang-flag">${lang.flag || '🌐'}</span>
                <span class="lang-name">${lang.nativeName}</span>
            `;

            btn.onclick = (e) => {
                e.preventDefault();
                this.changeLanguage(langCode);
            };
            listContainer.appendChild(btn);
        });

        // Ensure close button works
        const closeBtn = document.getElementById('closeLanguageMenu');
        if (closeBtn) {
            closeBtn.onclick = (e) => {
                e.preventDefault();
                this.closeLanguageMenu();
            };
        }
    },

    toggleMoreMenu(show) {
        const menu = document.getElementById('moreNavMenu');
        const triggerBtn = document.getElementById('moreBtn');

        if (menu) {
            const isHidden = menu.classList.contains('hidden');
            const shouldShow = show !== undefined ? show : isHidden;

            if (shouldShow) {
                menu.classList.remove('hidden');
                menu.style.display = 'flex';
                // Focus close button or first element
                const closeBtn = document.getElementById('closeMoreMenuBtn');
                if (closeBtn) setTimeout(() => closeBtn.focus(), 50);
            } else {
                menu.classList.add('hidden');
                menu.style.display = 'none';
                if (triggerBtn) triggerBtn.focus();
            }
        }
    },

    toggleLanguageMenu() {
        // Check for DEMO version
        const isDemo = window.location.href.includes('/DEMO/') || window.location.pathname.includes('/DEMO/');
        if (isDemo) {
            alert('El cambio de idioma no está disponible en esta versión DEMO.');
            return;
        }

        const menu = document.getElementById('languageMenu');
        if (menu) {
            const isHidden = menu.classList.contains('hidden');
            if (isHidden) {
                this.populateLanguageMenu(); // Ensure buttons & events are fresh
                menu.classList.remove('hidden');
                menu.classList.add('active');
                const closeBtn = document.getElementById('closeLanguageMenu');
                if (closeBtn) setTimeout(() => closeBtn.focus(), 50);
            } else {
                this.closeLanguageMenu();
            }
        }
    },

    closeLanguageMenu() {
        const menu = document.getElementById('languageMenu');
        const triggerBtn = document.getElementById('languageBtn');
        if (menu) {
            menu.classList.add('hidden');
            menu.classList.remove('active');
            if (triggerBtn) triggerBtn.focus();
        }
    },

    changeLanguage(langCode) {
        if (!window.LANGUAGES || !window.LANGUAGES[langCode]) return;

        window.currentLanguage = langCode;
        this.updateUILanguage();
        this.populateLanguageMenu();

        const contextsPreview = document.getElementById('contextsPreview');
        if (contextsPreview && !contextsPreview.classList.contains('hidden')) {
            this.populateContextsPreview();
        }

        if (window.playWelcomeMessage) {
            window.playWelcomeMessage();
        }

        this.closeLanguageMenu();
    },

    toggleProblemText() {
        // Nueva lógica unificada de minimizado/colapsado
        const section = document.querySelector('.problem-statement-section');
        const container = document.getElementById('problemTextContainer');
        const btn = document.getElementById('toggleProblemBtn');

        if (!section || !container || !btn) return;

        // Comprobar estado actual (minimized o collapsed)
        const isMinimized = section.classList.contains('minimized');
        const isCollapsed = container.classList.contains('collapsed');

        if (isMinimized || isCollapsed) {
            // MOSTRAR (Expandir)
            section.classList.remove('minimized');
            container.classList.remove('collapsed');
            btn.classList.add('expanded');

            // Asegurar que el scroll va al problema
            setTimeout(() => {
                container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 100);
        } else {
            // OCULTAR (Colapsar completamente)
            section.classList.remove('minimized'); // Limpiar estado residual
            container.classList.add('collapsed');
            btn.classList.remove('expanded');
        }
    },

    showTeacherPinModal() {
        let pinModal = document.getElementById('adultPinModal');
        const validPin = window.UserManager ? window.UserManager.getTeacherPin() : '1234';

        if (!pinModal) {
            const html = `
            <div id="adultPinModal" class="modal hidden" style="z-index: 1050; display: flex; align-items: center; justify-content: center; position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(15, 23, 42, 0.65); backdrop-filter: blur(8px);">
                <div class="modal-content" style="max-width: 440px; width: 90%; padding: 2rem; text-align: center; border-radius: 24px; background: #ffffff; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); border: 1px solid #e2e8f0;">
                    <div style="width: 60px; height: 60px; background: #e0f2fe; color: #0284c7; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 15px; font-size: 1.8rem; box-shadow: 0 4px 10px rgba(2, 132, 199, 0.2);">
                        🔒
                    </div>
                    <h2 style="font-size: 1.6rem; color: #0f172a; margin: 0 0 6px 0; font-weight: 800;">Área de Gestión</h2>
                    <p style="color: #64748b; font-size: 0.95rem; margin: 0 0 16px 0;">Control de acceso para docentes, familias y evaluadores editoriales.</p>

                    <!-- Píldora de PIN por defecto con botón directo para evaluadores -->
                    <div style="background: #f0fdf4; border: 1.5px dashed #86efac; border-radius: 14px; padding: 12px 14px; margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between; gap: 10px; text-align: left;">
                        <div>
                            <span style="display: block; font-size: 0.78rem; color: #166534; text-transform: uppercase; font-weight: 800; letter-spacing: 0.5px;">PIN Demostración</span>
                            <strong id="defaultPinBadge" style="font-size: 1.25rem; color: #15803d; letter-spacing: 3px;">${validPin}</strong>
                        </div>
                        <button type="button" id="useDemoPinBtn" style="background: #16a34a; color: white; border: none; border-radius: 10px; padding: 8px 14px; font-size: 0.85rem; font-weight: 800; cursor: pointer; transition: all 0.2s; box-shadow: 0 2px 5px rgba(22, 163, 74, 0.3);">
                            ⚡ Usar PIN Demo
                        </button>
                    </div>

                    <div style="margin-bottom: 20px;">
                        <input type="password" id="adultPinInputField" maxlength="6" inputmode="numeric" placeholder="Introduce PIN" style="width: 100%; max-width: 220px; padding: 12px 16px; font-size: 1.5rem; text-align: center; letter-spacing: 8px; border: 2px solid #cbd5e1; border-radius: 14px; outline: none; font-weight: 800; color: #0f172a; box-sizing: border-box;" />
                        <div id="adultPinErrorMsg" style="color: #ef4444; font-size: 0.88rem; font-weight: 700; margin-top: 8px; min-height: 22px;"></div>
                    </div>

                    <div style="display: flex; gap: 12px; justify-content: center;">
                        <button type="button" id="adultPinCancelBtn" class="btn btn-secondary" style="flex: 1; padding: 12px; font-size: 1rem; border-radius: 12px; cursor: pointer;">
                            Cancelar
                        </button>
                        <button type="button" id="adultPinSubmitBtn" class="btn btn-primary" style="flex: 1; padding: 12px; font-size: 1rem; border-radius: 12px; cursor: pointer; background: #3b82f6;">
                            Acceder →
                        </button>
                    </div>
                </div>
            </div>`;
            document.body.insertAdjacentHTML('beforeend', html);
            pinModal = document.getElementById('adultPinModal');

            const input = document.getElementById('adultPinInputField');
            const errorMsg = document.getElementById('adultPinErrorMsg');
            const submitBtn = document.getElementById('adultPinSubmitBtn');
            const cancelBtn = document.getElementById('adultPinCancelBtn');
            const useDemoBtn = document.getElementById('useDemoPinBtn');

            const closePinModal = () => {
                pinModal.classList.add('hidden');
                input.value = '';
                errorMsg.textContent = '';
            };

            const verifyPin = (enteredPin) => {
                const currentValidPin = window.UserManager ? window.UserManager.getTeacherPin() : '1234';
                if (enteredPin === currentValidPin) {
                    closePinModal();
                    this.showAdultMenuModal();
                } else {
                    errorMsg.textContent = '❌ PIN incorrecto. Usa 1234 para la demo.';
                    input.value = '';
                    input.focus();
                }
            };

            submitBtn.onclick = () => verifyPin(input.value.trim());
            useDemoBtn.onclick = () => {
                const currentValidPin = window.UserManager ? window.UserManager.getTeacherPin() : '1234';
                input.value = currentValidPin;
                verifyPin(currentValidPin);
            };
            cancelBtn.onclick = closePinModal;
            pinModal.onclick = (e) => {
                if (e.target === pinModal) closePinModal();
            };
            input.onkeydown = (e) => {
                if (e.key === 'Enter') verifyPin(input.value.trim());
            };
        }

        pinModal.classList.remove('hidden');
        const inputField = document.getElementById('adultPinInputField');
        const errorMsgField = document.getElementById('adultPinErrorMsg');
        if (errorMsgField) errorMsgField.textContent = '';
        if (inputField) {
            inputField.value = '';
            setTimeout(() => inputField.focus(), 150);
        }
    },

    showAdultMenuModal() {
        let adultMenu = document.getElementById('adultMenuModal');
        if (!adultMenu) {
            const html = `
            <div id="adultMenuModal" class="modal hidden" style="z-index: 1050; display: flex; align-items: center; justify-content: center; position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(15, 23, 42, 0.65); backdrop-filter: blur(8px);">
                <div class="modal-content" style="max-width: 520px; width: 92%; padding: 2rem; text-align: center; border-radius: 24px; background: #f8fafc; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); max-height: 90vh; overflow-y: auto;">
                    <div style="width: 100%; display: flex; justify-content: flex-start; margin-bottom: 15px;">
                        <button class="btn-atras-unificado" onclick="document.getElementById('adultMenuModal').classList.add('hidden')">⬅️ ATRÁS</button>
                    </div>
                    <h2 style="font-size: 1.7rem; margin-bottom: 1.2rem; color: #1e293b; font-weight: 800;">⚙️ Área de Gestión</h2>
                    <div style="display: flex; flex-direction: column; gap: 12px;">
                        <button class="btn" style="background: #ec4899; color: white; padding: 14px; font-size: 1.15rem; border-radius: 14px; font-weight: bold; box-shadow: 0 4px 6px rgba(236, 72, 153, 0.3); border:none; cursor:pointer;"
                                onclick="document.getElementById('adultMenuModal').classList.add('hidden'); if(window.ParentsDashboard) window.ParentsDashboard.show('teacher')">
                            📄 Profesores / Editorial (Dashboard)
                        </button>
                        <button class="btn" style="background: #8b5cf6; color: white; padding: 14px; font-size: 1.15rem; border-radius: 14px; font-weight: bold; box-shadow: 0 4px 6px rgba(139, 92, 246, 0.3); border:none; cursor:pointer;"
                                onclick="document.getElementById('adultMenuModal').classList.add('hidden'); if(window.ParentsDashboard) window.ParentsDashboard.show('parent')">
                            👨‍👩‍👧‍👦 Familias
                        </button>
                        <button class="btn" style="background: #06b6d4; color: white; padding: 14px; font-size: 1.15rem; border-radius: 14px; font-weight: bold; box-shadow: 0 4px 6px rgba(6, 182, 212, 0.3); border:none; cursor:pointer;"
                                onclick="document.getElementById('adultMenuModal').classList.add('hidden'); const langMenu = document.getElementById('languageMenu'); if(langMenu) langMenu.classList.remove('hidden');">
                            🌐 Cambiar Idioma
                        </button>
                        <button class="btn" style="background: #f59e0b; color: white; padding: 14px; font-size: 1.15rem; border-radius: 14px; font-weight: bold; box-shadow: 0 4px 6px rgba(245, 158, 11, 0.3); border:none; cursor:pointer;"
                                onclick="document.getElementById('adultMenuModal').classList.add('hidden'); if(window.ProblemEditor) window.ProblemEditor.open()">
                            ✏️ Editor de Problemas
                        </button>
                        <button class="btn" style="background: #cbd5e1; color: #334155; padding: 14px; font-size: 1.15rem; border-radius: 14px; font-weight: bold; border:none; cursor:pointer;"
                                onclick="document.getElementById('adultMenuModal').classList.add('hidden'); if(window.GdprModal) window.GdprModal.open()">
                            🛡️ Política de Privacidad y RGPD
                        </button>
                        <a href="mailto:apps@sswork.es?subject=[Detectim%C3%A1ticas%20B2B]%20Consulta%20desde%20%C3%81rea%20de%20Gesti%C3%B3n&body=Hola%20equipo%20de%20Detectim%C3%A1ticas,%0A%0ADeseo%20realizar%20una%20consulta%20comercial/t%C3%A9cnica%20desde%20el%20%C3%81rea%20de%20Gesti%C3%B3n:%0A%0A---%0A(Enviado%20desde%20Detectim%C3%A1ticas%20Web%20App)" class="btn" style="background: #1e293b; color: #60a5fa; padding: 14px; font-size: 1.05rem; border-radius: 14px; font-weight: bold; text-decoration: none; display: flex; align-items: center; justify-content: center; gap: 8px; border: 1px solid #334155;">
                            ✉️ Contacto: apps@sswork.es
                        </a>
                    </div>
                </div>
            </div>`;
            document.body.insertAdjacentHTML('beforeend', html);
            adultMenu = document.getElementById('adultMenuModal');
        }
        adultMenu.classList.remove('hidden');
    }
};

// Aliases para mantener compatibilidad
window.initializeUI = () => window.UIManager.init();
window.updateUILanguage = () => window.UIManager.updateUILanguage();
window.populateLanguageMenu = () => window.UIManager.populateLanguageMenu();
window.populateContextsPreview = () => window.UIManager.populateContextsPreview();
window.toggleLanguageMenu = () => window.UIManager.toggleLanguageMenu();
window.closeLanguageMenu = () => window.UIManager.closeLanguageMenu();
window.changeLanguage = (lang) => window.UIManager.changeLanguage(lang);
window.toggleProblemText = () => window.UIManager.toggleProblemText();

// Expose UIManager globally
window.UIManager = UIManager;

// Toggle top tools dropdown
document.addEventListener('DOMContentLoaded', () => {
    const topToolsBtn = document.getElementById('topToolsBtn');
    const toolsDropdown = document.getElementById('toolsDropdown');
    if (topToolsBtn && toolsDropdown) {
        topToolsBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            toolsDropdown.classList.toggle('hidden');
        });
        document.addEventListener('click', (e) => {
            if (!toolsDropdown.contains(e.target) && e.target !== topToolsBtn) {
                toolsDropdown.classList.add('hidden');
            }
        });
    }
});

// Workspace button in dropdown
document.addEventListener('DOMContentLoaded', () => {
    const openWorkspaceBtn = document.getElementById('openWorkspaceBtn');
    if (openWorkspaceBtn) {
        openWorkspaceBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (window.WorkBoard) {
                window.WorkBoard.open();
            }
            // Close dropdown
            const toolsDropdown = document.getElementById('toolsDropdown');
            if (toolsDropdown) toolsDropdown.classList.add('hidden');
        });
    }
});
